import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const latestArticles = articles.slice(0, 3);

export default function LatestArticles() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-14">
          <div>
            <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full mb-4">
              最新文章
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950">
              热门内容推荐
            </h2>
          </div>
          <Link
            to="/category/latest-news"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 font-medium hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.publishDate}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.summary}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/latest-news"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium hover:text-primary-700 transition-colors cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}